import { GetInviteLinkTeamMeta, GetInviteLinkTeamPayload } from 'types/store/GetInviteLinkTeam';
import { createAsyncReducer } from 'utils/Redux';

import { getInviteLinkTeamActions } from '../actions';

export default createAsyncReducer<GetInviteLinkTeamMeta, GetInviteLinkTeamPayload>(getInviteLinkTeamActions);
